/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type SocialMediaEmbedApiProps = {
  technicalName: string
  title?: Maybe<string>
  subtitle?: Maybe<string>
  identifiers: string[]
  socialMediaType: 'InstagramPost' | 'InstagramReel' | 'TikTokPost' | 'XPost'
  size: 'Small' | 'Medium' | 'Large'
}

/* Schemas */
export const SocialMediaEmbedApiPropsSchema = z.object({
  technicalName: z.string(),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  identifiers: z.array(z.string()),
  socialMediaType: z.enum([
    'InstagramPost',
    'InstagramReel',
    'TikTokPost',
    'XPost',
  ]),
  size: z.enum(['Small', 'Medium', 'Large']),
})

/* Schemas validation */
type TestSocialMediaEmbedProps = ExpectTrue<
  Equal<
    SocialMediaEmbedApiProps,
    z.infer<typeof SocialMediaEmbedApiPropsSchema>
  >
>
